<template>
    <div class="background">
        <div class="overlay"></div>
        <div class="container-fluid">
            <div class="col-lg-12 pt-4 header">
                <div class="logo"></div>
                <div class="login"></div>
            </div>

            <div class="col-lg-12 col-sm-12 login-container">
                <div class="col-lg-7 col-sm-7 app-title">
                    <div class="hero-badge">Secure verification</div>
                    <div class="logo"><img src="/logo.png" alt="PlePower"></div>
                    <h2>PlePower</h2> 
                    <p>Fast, reliable and secured transactions</p>
                </div>
            
                <div class="col-lg-4 col-sm-4 login-form">
                    <div class="login-form-inner">
                        <div class="verification-card-header">
                            <span class="verification-pill">Create PIN</span>
                            <h3>Enter the one-time code</h3>
                            <p>We sent a 4-digit code to your email address & Phone number. Use it to create your pin.</p>
                        </div>

                        <div class="verification-summary">
                            <!-- <div class="summary-chip">
                                <span>Step 2 of 2</span>
                                <strong>Create pin</strong>
                            </div> -->
                            <div class="summary-chip subtle">
                                <span>Need help?</span>
                                <strong>Check spam if you can't find it</strong>
                            </div>
                        </div>

                        <div class="inputs1"> 
                            <input type="text" maxlength="1" inputmode="numeric" pattern="[0-9]*" autocomplete="one-time-code" id="text" class="form-control inputs-field1"  v-model="verify_code1" required @input="moveToNext(1)"  @keydown.backspace="moveToPrevious($event, 1)" ref="input1">
                            <input type="text" maxlength="1" inputmode="numeric" pattern="[0-9]*" autocomplete="one-time-code" id="text" class="form-control inputs-field1"  v-model="verify_code2" required @input="moveToNext(2)"  @keydown.backspace="moveToPrevious($event, 2)" ref="input2">
                            <input type="text" maxlength="1" inputmode="numeric" pattern="[0-9]*" autocomplete="one-time-code" id="text" class="form-control inputs-field1"  v-model="verify_code3" required @input="moveToNext(3)"  @keydown.backspace="moveToPrevious($event, 3)" ref="input3">
                            <input type="text" maxlength="1" inputmode="numeric" pattern="[0-9]*" autocomplete="one-time-code" id="text" class="form-control inputs-field1"  v-model="verify_code4" required @input="moveToNext(4)"  @keydown.backspace="moveToPrevious($event, 4)" ref="input4">
                        </div>
                        <label v-if="timeLeft > 0">
                        This OTP expires in {{ formattedTime }}
                        </label>

                        <label v-else style="color:red;">
                        OTP expired
                        </label>
                        <div class="inputs2"> 
                            <div class="password">
                                <label for="">Pin <span class="text-danger">*</span></label>
                                
                                <input
                                    :type="showPin ? 'text' : 'password'"
                                    id="show_text"
                                    class="form-control inputs-field"
                                    placeholder="Enter 4-digit pin"
                                    v-model="password"
                                    maxlength="4"
                                    inputmode="numeric"
                                    pattern="[0-4]*"
                                    autocomplete="new-password"
                                    @input="password = password.replace(/[^0-9]/g, '').slice(0, 4)"
                                    required
                                >

                                <span class="p-viewer" @click="showPin = !showPin">
                                    <i v-if="!showPin" class="fa fa-eye" aria-hidden="true"></i>
                                    <i v-else class="fa fa-eye-slash" aria-hidden="true"></i>
                                </span>
                            </div>

                            <div class="password">
                                <label for="">Confirm Pin <span class="text-danger">*</span></label>
                                
                                <input
                                    :type="showConfirmPin ? 'text' : 'password'"
                                    id="show_text2"
                                    class="form-control inputs-field"
                                    placeholder="Confirm 4-digit pin"
                                    v-model="confirm_password"
                                    maxlength="4"
                                    inputmode="numeric"
                                    pattern="[0-4]*"
                                    autocomplete="new-password"
                                    @input="confirm_password = confirm_password.replace(/[^0-9]/g, '').slice(0, 4)"
                                    required
                                >

                                <span class="p-viewer2" @click="showConfirmPin = !showConfirmPin">
                                    <i v-if="!showConfirmPin" class="fa fa-eye" aria-hidden="true"></i>
                                    <i v-else class="fa fa-eye-slash" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <div class="password-rules">
                            <span>Use at least 4 characters</span>
                            <span></span>
                        </div>
                    
                        <div class="btn-inputs">
                            <button id="submit4" class="btn btn-danger btn-block verify-btn" :disabled="isSubmitButtonDisabled1" @click="verify_create_pin()" v-if="!loading4">Validate & Create Pin </button>
                            <button class="btn btn-danger btn-block verify-btn" type="button" disabled v-if="loading4">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                            <p class="helper-copy">By continuing, you confirm this otp is valid.</p>
                        </div>               
                    </div>
                    <p>&nbsp;</p> 
                </div>
            </div>
        </div>
       
    </div>
</template>
<script>
    import Vue from 'vue'
    import VueCountryCode from "vue-country-code";
    import swal from 'sweetalert2';
    
    Vue.use(VueCountryCode);
    
    export default {
        
        name: 'SignupPage',
        components: {
    
        },
        
        data() {
        return {
            timeLeft: 30 * 60, // 30 minutes in seconds
            interval: null,
            appTitle: "PlePower",
            getStarted: true,
            verifyEmail: false,
            submit_3: false,
            firstname: '',
            lastname: '',
            username: '',
            email_address: '',
            phone_number: '',
            password: '',
            confirm_password: '',
            phone_number_code: '',
            verify_code1: '',
            verify_code2: '',
            verify_code3: '',
            verify_code4: '',
            loading3: false,
            loading4: false,
            tokenValid: true,
            terms_conditions: '',
            selectedCategory: '',
            showConfirmPin: false,
            showPin: false,
          
        };
      },
    
      beforeMount(){
        document.title = this.appTitle
      },
      mounted() {
            this.interval = setInterval(() => {
        if (this.timeLeft > 0) {
            this.timeLeft = this.timeLeft - 1; // IMPORTANT: explicit reassignment
        } else {
            clearInterval(this.interval);
        }
        }, 1000);
      },
      created(){
        
      },
      computed: {
        formattedTime() {
        const minutes = Math.floor(this.timeLeft / 60);
        const seconds = this.timeLeft % 60;

        return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
        },

    
        isPhoneNumberValid() {
        return (
          this.phone_number === ''
        );
      },
      isTokenValid(){
        return (
          this.validate_token === ''
        );
      },

      isSubmitButtonDisabled1() {
            return (
            this.verify_code1 === '' ||
            this.verify_code2 === '' ||
            this.verify_code3 === '' ||
            this.verify_code4 === '' ||
            this.password === '' ||
            this.confirm_password === '' 
            );
        }
      },
    
      methods:{
        
        moveToNext(index) {
            const verifyCode = this[`verify_code${index}`];
            if (verifyCode.length === 1) {
                const nextIndex = index + 1;
                if (nextIndex <= 4) {
                    this.$refs[`input${nextIndex}`].focus();
                }
            }
        },
        handlePaste(event) {
        event.preventDefault(); // Prevent the default paste behavior
        const pasteData = event.clipboardData.getData('text');
        if (pasteData.length === 4) {
            this.verify_code1 = pasteData[0];
            this.verify_code2 = pasteData[1];
            this.verify_code3 = pasteData[2];
            this.verify_code4 = pasteData[3];

            // Move focus to the last input field
            this.$nextTick(() => {
            this.$refs.input4.focus();
            });
        }
        },

        moveToPrevious(event, index) {
        // If current input already has value, allow normal delete
            if (this[`verify_code${index}`]) {
                this[`verify_code${index}`] = '';
                return;
            }

            const previousIndex = index - 1;

            if (previousIndex >= 1) {
                this.$refs[`input${previousIndex}`].focus();
                this[`verify_code${previousIndex}`] = '';
            }
        },

        showText(){
            const input =  document.getElementById('show_text');
            if (input.getAttribute("type") === "password") {
                input.setAttribute("type", "text");
                    document.getElementById('eye_close').style.display="none";
                    document.getElementById('eye_open').style.display="block";
                } else {
                input.setAttribute("type", "password");
                    document.getElementById('eye_close').style.display="block";
                    document.getElementById('eye_open').style.display="none";
            }
        },
        showText2(){
            const input =  document.getElementById('show_text2');
            if (input.getAttribute("type") === "password") {
                input.setAttribute("type", "text");
                    document.getElementById('eye_close2').style.display="none";
                    document.getElementById('eye_open2').style.display="block";
                } else {
                input.setAttribute("type", "password");
                    document.getElementById('eye_close2').style.display="block";
                    document.getElementById('eye_open2').style.display="none";
                }
        },
        onSelect({name, iso2, dialCode}) {
           console.log(name, iso2, dialCode);
           this.phone_number_code = dialCode
        },
        select1(){
            if (this.education_level == "") {
                document.getElementById("submit1").disabled = false
                return;
            }
    
            document.getElementById("submit1").disabled = true
        },
    
        select2(){
            if (this.work_experience == "") {
                document.getElementById("select_field").disabled = false
                return;
            }
            document.getElementById("select_field").disabled = true
        },
    
        select3(){
            if (this.interests == "") {
                document.getElementById("submit3").disabled = false
                return;
            }
            document.getElementById("submit3").disabled = true
        },
    
        select4(){
            if (this.work_field == "") {
                document.getElementById("submit2").disabled = false
                return;
            }
            document.getElementById("submit2").disabled = true
        },

        async verify_create_pin(){
            try {

                if (!this.verify_code1) {
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: 'Code is required',
                    })
                    return;
                }
                if (!this.verify_code2) {
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: 'Code is required',
                    })
                    return;
                }
                if (!this.verify_code3) {
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: 'Code is required',
                    })
                    return;
                }
                if (!this.verify_code4) {
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: 'Code is required',
                    })
                    return;
                }

                this.loading4 = true
                
                const verify_code = this.verify_code1+''+this.verify_code2+''+this.verify_code3+''+this.verify_code4

                const response = await this.$http.post('/verify-otp-create-pin', {
                    passcode: verify_code,
                    password: this.password,
                    confirm_password: this.confirm_password,
                })


                if( !response.data.success ){
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: response.data.message,
                    })
                    return;
                }

                swal.fire({
                    icon: 'success',
                    title: 'Success',
                    width: 450,
                    height: 5,
                    text: "Your pin has been created successfully. Please login to fund your wallet.",
                })

                this.$router.push('/')
                return;

                } catch (err) {
                    this.loading4 = false

                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: err.response ? err.response.data.message : err.message,
                    })
                    console.log(err);
                    return;
                }
        },
    
        validatePassword() {
        // Get the password and confirm_password values
        var password = document.getElementById("password").value;
        var confirm_password = document.getElementById("confirm_password").value;
    
        // Define regular expressions for each requirement
        var digitRegex = /\d/;
        var letterRegex = /[a-zA-Z]/;
        var specialCharRegex = /[@#$%^&*!]/;
    
        // Check if the passwords match
        if (password !== confirm_password) {
            document.getElementById("password-feedback").style.color = "red";
            document.getElementById("password-feedback").textContent = "Passwords do not match!";
            return;
        }
    
        // Check each requirement individually
        var missingRequirements = [];
        if (!password.match(digitRegex)) {
            missingRequirements.push("a digit");
        }
        if (!password.match(letterRegex)) {
            missingRequirements.push("a letter");
        }
        if (!password.match(specialCharRegex)) {
            missingRequirements.push("a special character (@#$%^&*!)");
        }
    
        // Provide feedback based on the missing requirements
        if (missingRequirements.length > 0) {
            var errorMessage = "Password is not strong. Missing: " + missingRequirements.join(', ');
            document.getElementById("password-feedback").style.color = "red";
            document.getElementById("password-feedback").textContent = errorMessage;
            // You can further customize the error message or take other actions as needed
        } else {
            document.getElementById("password-feedback").style.color = "green";
            document.getElementById("password-feedback").textContent = "Password is strong and matches!";
            // You can proceed with the signup process here
        }
        },
    
        startCountdown(hours, minutes) {
                this.totalSeconds = (hours * 3600) + (minutes * 60);
                this.updateTimer();
        },
        updateTimer() {
            if (this.totalSeconds > 0) {
                this.totalSeconds--;
                this.timer = setTimeout(this.updateTimer, 1000);
            }
        },
        stopTimer() {
            if (this.totalSeconds > 0) {
                this.totalSeconds = 0;
            }
        },
        stopCountdown(hours, minutes) {
                this.totalSeconds = (hours * 3600) + (minutes * 60);
                this.stopTimer();
        },
        checkInput() {
          this.tokenValid = this.validateFiveDigitInput(this.validate_token);
        },
        validateFiveDigitInput(input) {
          // Regular expression to match exactly five digits
          var regex = /^\d{5}$/;
    
          // Test the input against the regular expression
          return regex.test(input);
        },
    
      },
      beforeDestroy() {
            if (this.interval) {
            clearInterval(this.interval);
            }
      }
    }
</script>
<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
    
    .container-fluid{
        padding-left: 0px;
        padding-right: 0px;
    }
    .terms-conditions{
        margin-top: 10px;
        padding: 0.3rem;
        text-align: center;
        font-size: 10px;
        span{
            color: #24562B;
        }
       
        a {
            margin-top: 10px;
            text-decoration: none;
            font-size: 10px;
        }
    }
    .form-check-label{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
    }
    .p-viewer, .p-viewer2{
        float: right;
        margin-top: -33px;
        margin-right: 10px;
        position: relative;
        z-index: 1;
        cursor:pointer;
        font-size: 16px;
    }
    .background{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        position: relative;
        overflow: hidden;
        backdrop-filter: blur(16px);
        background:
            radial-gradient(circle at top left, rgba(36, 86, 43, 0.55), transparent 32%),
            radial-gradient(circle at bottom right, rgba(41, 121, 255, 0.18), transparent 26%),
            url(../assets/bg.jpg) no-repeat fixed center;
        background-size: cover;
    }
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #012b20; /* Change the color and opacity here */
        opacity: 0.9;
      }
      
        .container{
            display: flex;
            flex-direction: column;
            margin-left: 0px;
            margin-right: 0px;
            margin-bottom: 0px;
            width: 100%;
        }
        .header{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-content: center;
            text-transform: normal;
            font-size: 12px;
            font-weight: 700;
            color: #fff;
            font-family: Poppins;
            margin-bottom: 18px;
            padding-right: 50px;
            .logo{
                img{
                    height: 50px;
                    width: auto;
                }
            }
    
            a{
                color: #fff;
                text-decoration: none;
                font-weight: 700;
            }
            .login{
                font-weight: 500;
                color: #fff !important;
                a{
                    font-weight: 700;
                }
            }
        }
        .login-container{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
        }
    
        .get-started{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 10px;
            padding-bottom: 20px;
            font-family: Poppins;
            font-size: 30px;
            font-weight: 600;
            word-wrap: break-word;
            text-align: center;
            color: #fff;
            text-transform: capitalize;
        }
        .app-title{
            display: flex;
            flex-direction: column;
            align-items:center;
            justify-content: center;
            font-family: Poppins;
            font-size: 30px;
            font-weight: bold;
            text-align: center;
            color: #fff;
            padding: 3rem 2rem;
            text-transform: capitalize;
            position: relative;
            z-index: 1;
            gap: 8px;

            .hero-badge{
                display: inline-flex;
                align-items: center;
                justify-content: center;
                padding: 8px 14px;
                border-radius: 999px;
                border: 1px solid rgba(255, 255, 255, 0.22);
                background: rgba(255, 255, 255, 0.08);
                color: #fff;
                font-size: 11px;
                letter-spacing: 0.12em;
                text-transform: uppercase;
            }
            .logo{
                img{
                    height: 70px;
                    width: auto;
                }
            }
        
            h2{
                font-family: Poppins;
                font-size: 60px;
                color: white;
                text-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
                margin-bottom: 6px;

            }
            p{
                font-family: Poppins;
                font-size: 15px;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.9);
                text-transform: capitalize;
                text-align: center;
            }
        }
     
        .login-form{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .login-form-inner{
            display: flex;
            flex-direction: column;
            background: linear-gradient(180deg, #ffffff 0%, #f8fbf8 100%);
            border-radius: 22px;
            padding: 2rem;
            width: 100%;
            box-shadow: 0 24px 70px rgba(0, 0, 0, 0.25);
            border: 1px solid rgba(36, 86, 43, 0.08);
            font-family: Poppins;
            font-size: 13px;
            font-weight: 500;
            color: #000 !important;
            position: relative;
            overflow: hidden;
        }

        .login-form-inner::before{
            content: "";
            position: absolute;
            inset: 0 auto auto 0;
            width: 100%;
            height: 6px;
            background: linear-gradient(90deg, #24562B 0%, #8bbf9a 100%);
        }
    
        .counter{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-content: center;
            border-bottom: 1px solid #ccc;
            border-left: 1px solid #ccc;
            border-right: 1px solid #ccc;
            border-top: 1px solid #ccc;
            padding: 4px;
            height: 30px;
            border-radius: 3px;
    
            span{
                color: #000;
            }
            .step-title{
                font-weight: 500;
                font-size: 12px !important;
            }
        }
        .inputs{
            display: flex;
            flex-direction: row;
            margin-top: 10px;
            border-radius: 3px;
            font-size:11px;
            font-weight: 400;
            width: 100%;

            .inputs-field{
                font-size: 12px;
                font-family: Poppins;
                height: 40px;
               
            }
    
           div{
            margin: 2px;
            .inputs-field{
                font-size: 12px;
                font-family: Poppins;
                height: 40px;
            }
           }
        }
        .inputs1{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
            margin-top: 16px;
            margin-bottom: 10px;
            border-radius: 3px;
            font-size:11px;
            font-weight: 400;

            .inputs-field1{
                font-size: 20px;
                font-weight: 700;
                font-family: Poppins;
                text-align: center;
                height: 58px;
                width: 100%;
                margin: 0;
                border: 1px solid #d4ddd6;
                border-radius: 14px;
                background: linear-gradient(180deg, #ffffff 0%, #f9fbf9 100%);
                color: #172018;
                box-shadow: inset 0 1px 0 rgba(255,255,255,0.75);
                outline: none;
            }

            .inputs-field1:focus{
                border-color: #24562B;
                box-shadow: 0 0 0 4px rgba(36, 86, 43, 0.12);
            }
        }
        .inputs2{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 15px;
            margin-bottom: 10px;
                gap: 10px;
                border-radius: 3px;
                font-size:11px;
                font-weight: 400;
    
                .password{
                    position: relative;
                    width: 100%;
                    
                    label{
                        font-size: 14px;
                        font-weight: 500;
                        color: #172018;
                        margin-bottom: 4px;
                        display: block;
                    }
                }
        }
        .btn-inputs1{
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            border-radius: 3px;
        }
        .btn-inputs{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            margin-top: 10px;
            border-radius: 3px;
        }
        
        .btn-danger{
            text-transform: uppercase;
            font-size: 14px;
            font-family: Poppins;
            background: #24562B;
            border: 0px;
            height: 52px;
            border-radius: 12px;
            box-shadow: 0 12px 25px rgba(36, 86, 43, 0.18);
        }
        .verify-btn{
            width: 100%;
        }
        .verification-card-header{
            display: flex;
            flex-direction: column;
            gap: 4px;
            text-align: left;
            margin-top: 12px;
            z-index: 1;

            .verification-pill{
                display: inline-flex;
                align-self: flex-start;
                padding: 6px 12px;
                border-radius: 999px;
                background: rgba(36, 86, 43, 0.08);
                color: #24562B;
                font-size: 11px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.08em;
            }

            h3{
                margin: 0;
                font-size: 24px;
                font-weight: 700;
                color: #15211a;
            }

            p{
                margin: 0;
                font-size: 13px;
                line-height: 1.5;
                color: #69736d;
            }
        }
        .verification-summary{
            display: grid;
            grid-template-columns: 1fr;
            gap: 10px;
            margin-top: 18px;

            .summary-chip{
                display: flex;
                flex-direction: column;
                gap: 2px;
                padding: 12px 14px;
                border-radius: 14px;
                background: #f2f6f3;
                border: 1px solid rgba(36, 86, 43, 0.08);

                span{
                    font-size: 11px;
                    text-transform: uppercase;
                    letter-spacing: 0.08em;
                    color: #7a847f;
                    font-weight: 700;
                }

                strong{
                    font-size: 13px;
                    color: #172018;
                }
            }

            .summary-chip.subtle{
                background: #ffffff;
            }
        }
        .helper-copy{
            margin-top: 12px;
            margin-bottom: 0;
            text-align: center;
            color: #7a847f;
            font-size: 12px;
        }
        .inputs-field{
            font-size: 14px;
            font-family: Poppins;
            height: 50px;
            //border: #24562B solid 1px;
        }
        .footer{
            display: flex;
            flex-direction: column;
        }
        .copyright{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-family: Poppins;
            font-size: 13px;
            color: #fff;
            background: #cccccc3b;
            padding: 0.3rem;
            width: 100%;
            //margin-top: 40px;
            bottom: 0;
            position: absolute;
            flex-shrink: 0;
        }
        .login{
            font-weight: 800;
            color: #fff !important;
            font-size: 15px
    
        }
    
        .timer{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            padding: 0.4rem;
            margin-top: -10px;
            margin-bottom: -10px;
            font-size: 20px;
           
        }

        body, html {
            height: 100%;
            margin: 0;
        }
       
        .login-container1 {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 20px; /* Optional: Add padding */
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better appearance */
            border-radius: 8px; /* Optional: Add border radius for better appearance */
        }
        
        .inputs1 input {
            margin-bottom: 10px; /* Optional: Add margin between inputs */
        }
        
        .btn-inputs button {
            margin-top: 10px; /* Optional: Add margin above the button */
        }
        
    
        @media screen and (max-width: 768px) {
            .background{
                font-family: Poppins !important;
                height: 100%;
                position: relative;
                backdrop-filter: blur(16px);
                background: url(../assets/bg.jpg) no-repeat fixed center;
                background-size: cover;
            }
            .overlay {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
              }
           
            .header{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-content: center;
                width: 100%;
                padding-right: 20px;
        
                .logo{
                    img{
                        height: 35px;
                        width: auto;
                    }
                }
            }
            .login{
                font-weight: 800;
                text-align: right;
                color: #000 !important;
            }
            .account{
                display: none;
            }
            .get-started{
                font-size: 14px;
            }
            .login-container{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
            .login-container1 {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                padding: 0px; /* Optional: Add padding */
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better appearance */
                border-radius: 8px; /* Optional: Add border radius for better appearance */
            }
            .app-title1{
                display: none
            }
            .app-title{
                font-size: 20px;
                font-weight: bold;
                color: #fff;
                padding: 0rem 0rem 1.5rem;
                text-align: center;
                .hero-badge{
                    font-size: 10px;
                    padding: 7px 12px;
                }
                h2{
                    font-size: 20px;
                }
                p{
                    font-family: Poppins;
                    font-size: 10px;
                }
            }
            .login-form{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
            }
            .login-form-inner{
                width: 100%;
                padding: 1rem;
                border-radius: 18px;
            }
            .verification-card-header{
                h3{
                    font-size: 20px;
                }
                p{
                    font-size: 12px;
                }
            }
            .inputs1{
                gap: 8px;
            }
            .inputs1 .inputs-field1{
                height: 52px;
                font-size: 18px;
            }
        }
</style>
